import { MuiPage } from "../../../components";
import MenuGroupEdit from "./menuGroup.edit";

export const MenuGroupAddEdit = () => {

    return (
        <MuiPage>
            <MenuGroupEdit />
        </MuiPage>
    );
}